module.exports = __webpack_public_path__ + "static/media/termopary12ru.6d655158.pdf";